import { formatDate } from '../../../common/SharedFunctions';

export const onRepaidDateCellRender = (e) => {
    const formatRepaidDate = (date: string) => {
        return (
            <>
                {!date && 'Not Set'}
                {date && formatDate(date)}{' '}
            </>
        );
    };
    const targetId = `repaidDate_${e.data.id}`;
    return (
        <>
            <div
                data-tip
                data-for={targetId}
            >
                {formatRepaidDate(e.data.repaidDate)}
            </div>
        </>
    );
};
